module.exports = __webpack_public_path__ + "static/media/0030_IMG_LES_STRUCTURES_ILV.481d8e7b.webp";